import React, { useState } from "react";
import { useDrop } from "react-dnd";
import DropFieldHere from "../../DropFieldHere";
import ConditionalFormattingModal from "./ConditionalFormattingModal";
import { RxCross2 } from "react-icons/rx";
import { MdOutlineArrowRight } from "react-icons/md";
import {
  getL2SheetProperty,
  removeLevel2PropertiesBynanoId,
} from "../../../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import AutoColorModal from "./AutoColorModal";
import { FaXmark } from "react-icons/fa6";
import { IoMdAdd } from "react-icons/io";
import AutoColorPoints from "../../../../../components/VizComponents/MapWithCordinate/AutoColorPoints";

export default function Aside2ConditionalFormatting({
  currentSheet,
  ControllerProps,
  VizchartType: vizType,
}) {
  const { title, single } = ControllerProps;
  const { Sheetid } = currentSheet;
  const { reduxKey } = ControllerProps;
  const [formattingModal, setFormattingModal] = useState(null);
  // console.log(single);
  // console.log(reduxKey);

  const [modalItemIndex, setModalItemIndex] = useState(-1);

  const droppedItems = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "customization", reduxKey);
  });
  // console.log(droppedItems);

  // console.log(modalItemIndex);

  const dispatch = useDispatch();

  const [{ isOver }, drop] = useDrop({
    accept: "Data",
    drop: (item) => {
      closeModal();
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const rows = useSelector((state) =>
    getL2SheetProperty(state, currentSheet.Sheetid, "query", "rows")
  );
  
  const valueColumns = useSelector((state) =>
    getL2SheetProperty(state, currentSheet.Sheetid, "query", "valueColumns")
  );
  // console.log(rows);
  
  const requiredArrayForContionalFormatting =
    vizType === "cordinatemap" ? rows : valueColumns;
  
  // console.log(requiredArrayForContionalFormatting);
  

  const conditionalFormattedData = useSelector((state) => {
    const conditionalFormattingArray = getL2SheetProperty(
      state,
      currentSheet.Sheetid,
      "customization",
      "conditionalFormatting"
    );
    return conditionalFormattingArray;
  });
  // console.log(conditionalFormattedData);

  const closeModal = () => {
    setFormattingModal(!formattingModal);
  };

  const removeItem = (conditionalFormattedData, index) => {
    dispatch(
      removeLevel2PropertiesBynanoId({
        reduxKey: "conditionalFormatting",
        Sheetid: currentSheet.Sheetid,
        parentKey: "customization",
        value: conditionalFormattedData[index],
      })
    );
  };

  const handleModal = (modal) => {
    setFormattingModal(modal);
  };

  const handleEdit = ({ index }) => {
    const selectedItem = conditionalFormattedData[index];

    if (selectedItem.formattingModalWas === "Auto") {
      setFormattingModal("Auto");
    } else {
      setFormattingModal("Custom");
    }

    setModalItemIndex(index);
  };

  return (
    <>
      <main className="flex flex-col items-start justify-start w-full gap-2">
        <h1 className="text-m w-full font-light text-left">{title}</h1>
        <div
          className={`w-full rounded h-full border border-gray-700 flex flex-col items-center justify-center truncate`}
        >
          {droppedItems && droppedItems.length
            ? droppedItems.map((item, index) => (
                <div key={index} className="w-[94%] rounded">
                  <div className="font-light py-[2px] h-8 text-sm w-full font-UberMoveTextRegular text-center bg-custom-gray text-black rounded flex items-center justify-evenly my-[0.15rem]">
                    <button className="ml-1 w-5 flex items-center justify-center h-5 border-gray-300">
                      <RxCross2
                        className="text-black text-l cursor-pointer font-medium"
                        onClick={() =>
                          removeItem(conditionalFormattedData, index)
                        }
                      />
                    </button>
                    <button className="w-[70%] border-x  border-gray-500 truncate ">
                      {item.rename}
                    </button>
                    <button
                      onClick={() => handleEdit({ modal: "Auto", index })}
                    >
                      <MdOutlineArrowRight className="text-black text-[25px] cursor-pointer" />
                    </button>
                  </div>
                </div>
              ))
            : null}
          {single ? (
            droppedItems.length === 1 ? null : (
              <button
                onClick={() => {
                  handleModal("Auto");
                  setModalItemIndex(-1);
                }}
                disabled={requiredArrayForContionalFormatting.length === 0}
                className="w-full flex gap-1 px-2 dropFieldHere"
                aria-label="Add rule"
              >
                <button
                  className={`text-left h-6 truncate bg-white text-gray-700 outline-dashed outline-2 outline-gray-400 rounded px-[2px] items-center  flex my-[6px] w-full text-sm`}
                >
                  <IoMdAdd /> {"Add rule"}
                </button>
              </button>
            )
          ) : (
            <button
              onClick={() => {
                handleModal("Auto");
                setModalItemIndex(-1);
              }}
              disabled={requiredArrayForContionalFormatting.length === 0}
              className="w-full flex gap-1 px-2 dropFieldHere"
              aria-label="Add rule"
            >
              <button
                className={`text-left h-6 truncate bg-white text-gray-700 outline-dashed outline-2 outline-gray-400 rounded px-[2px] items-center  flex my-[6px] w-full text-sm`}
              >
                <IoMdAdd /> {"Add rule"}
              </button>
            </button>
          )}
        </div>
        {["simpleTable","table"].includes(vizType) && formattingModal === "Custom" ? (
          <main className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
            <section className="bg-white rounded shadow-lg w-[50%] min-w-[50%]">
              <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
                Add New Color Formatter{" "}
                <button onClick={() => setFormattingModal(null)}>
                  <FaXmark />
                </button>
              </header>
              <ConditionalFormattingModal
                ControllerProps={ControllerProps}
                data={requiredArrayForContionalFormatting}
                conditionalFormattedData={conditionalFormattedData}
                currentSheet={currentSheet}
                handleModal={handleModal}
                closeModal={() => setFormattingModal(null)}
                modalItemIndex={modalItemIndex}
              />
            </section>
          </main>
        ) : null}
        {["simpleTable","table"].includes(vizType) && formattingModal === "Auto" ? (
          <AutoColorModal
            closeModal={() => setFormattingModal(null)}
            data={requiredArrayForContionalFormatting}
            currentSheet={currentSheet}
            conditionalFormattedData={conditionalFormattedData}
            modalItemIndex={modalItemIndex}
            ControllerProps={ControllerProps}
            handleModal={handleModal}
          />
        ) : null}
        {vizType === "cordinatemap" && formattingModal === "Auto" && (
          <AutoColorPoints
            setFormattingModal={setFormattingModal}
            data={requiredArrayForContionalFormatting}
            conditionalFormattedData={conditionalFormattedData}
            modalItemIndex={modalItemIndex}
            currentSheet={currentSheet}
            ControllerProps={ControllerProps}
            vizType={vizType}
          />
        )}
        {vizType === "areamap" && formattingModal === "Auto" ? (
          <AutoColorModal
            closeModal={() => setFormattingModal(null)}
            data={requiredArrayForContionalFormatting}
            currentSheet={currentSheet}
            conditionalFormattedData={conditionalFormattedData}
            modalItemIndex={modalItemIndex}
            ControllerProps={ControllerProps}
            handleModal={handleModal}
            vizType={vizType}
          />
        ) : null}
      </main>
    </>
  );
}
